var amdi18n={"__root":{"account":"Account","actions":"Actions","application_workspace":"Development Device Group","cancel":"Cancel","confirm":"Confirm","created_at":"Created","created_by":"Created By","delete":"Delete","deploy":"Deploy","deployment":"Deployment","description":"Description","destination":"Destination","development_device_group":"Development Device Group","device_group":"Device Group","devices":"Devices","factory_fixture_device_group":"Fixture Device Group","dut_devicegroup":"DUT Device Group","factory_imp":"Factory Imp","loading":"Loading","mac_address":"Mac Address","model":"Model","name":"Name","owner":"Owner","production_device_group":"Production Device Group","pre_factoryfixture_devicegroup":"Test Fixture Device Group","pre_production_devicegroup":"Test Production Device Group","pre_dut_devicegroup":"Test DUT Device Group","recommended":"recommended","run":"Run","sha":"SHA","unknown":"unknown","update":"Update","url":"URL"}};amdi18n.init=function(language){
		// get the default language
		if(!language){
			if(window._i18n && window._i18n.locale){
				language = window._i18n.locale;
			}else if(document.documentElement.lang){
				language = document.documentElement.lang;
			}else{
				language = 'root';
			}
		}
		var target = this['__' + language] || this.__root;

		// copy definition to root level
		if (target) {
			for (var name in target) {
				this[name] = target[name];
			}
		}

		// fallback to root
		for(var name in this.__root){
			if(typeof this[name] === 'undefined'){
				this[name] = this.__root[name];
			}
		}
	};amdi18n.init();module.exports=amdi18n;